const NEXTGEN_HOMEPAGE = "nextgen home page";
const NEXTGEN_SEARCHPAGE = "nextgen search page";
const NEXTGEN_CUSTOISATIONPAGE = "nextgen customisation page";
const NEXTGEN_SEARCH_CUSTOMISATIONPAGE = "nextgen search customisation page";
const NEXTGEN_NON_CUSTOMISATIONPAGE = "nextgen non customisation page";
const NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE =
  "nextgen search non customisation page";
const NEXTGEN_MENUPAGE = "nextgen menu page";
const NEXTGEN_LINKREWRITE_HOME = 'home';

export default {
  NEXTGEN_HOMEPAGE,
  NEXTGEN_SEARCHPAGE,
  NEXTGEN_CUSTOISATIONPAGE,
  NEXTGEN_SEARCH_CUSTOMISATIONPAGE,
  NEXTGEN_NON_CUSTOMISATIONPAGE,
  NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE,
  NEXTGEN_MENUPAGE,
  NEXTGEN_LINKREWRITE_HOME
};
